import React from 'react';
import { ThemeProvider } from '@aws-amplify/ui-react';
import '@aws-amplify/ui-react/styles.css';
import './App.css';
import DeckForgeApp from './components/DeckForgeApp';
import { AuthProvider } from './context/AuthContext';
import deckforgeLogo from './deckforge-logo.png';

// Auth is configured in index.tsx

// Customize Cognito sign-up form to include first and last name
const formFields = {
  signUp: {
    given_name: {
      label: 'First Name',
      placeholder: 'Enter your first name',
      order: 1,
      required: true,
    },
    family_name: {
      label: 'Last Name',
      placeholder: 'Enter your last name',
      order: 2,
      required: true,
    },
    email: {
      label: 'Email',
      placeholder: 'Enter your email',
      order: 3,
      required: true,
    },
    password: {
      label: 'Password',
      placeholder: 'Create a password',
      order: 4,
      required: true,
    },
    confirm_password: {
      label: 'Confirm Password',
      order: 5,
      required: true,
    },
  },
  signIn: {
    username: {
      label: 'Email',
      placeholder: 'Enter your email',
      required: true,
    },
    password: {
      label: 'Password',
      placeholder: 'Enter your password',
      required: true,
    },
  },
};

// Custom theme for Cognito UI
const components = {
  SignIn: {
    Header() {
      return (
        <div className="text-center mb-8">
          <img src={deckforgeLogo} alt="DeckForge Logo" className="w-16 h-16 mx-auto mb-4 rounded-lg" />
          <h2 className="text-2xl font-bold text-gray-900 mb-2">Welcome to DeckForge</h2>
          <p className="text-gray-600">Sign in to your account</p>
        </div>
      );
    }
  },
  SignUp: {
    Header() {
      return (
        <div className="text-center mb-8">
          <img src={deckforgeLogo} alt="DeckForge Logo" className="w-16 h-16 mx-auto mb-4 rounded-lg" />
          <h2 className="text-2xl font-bold text-gray-900 mb-2">Create an Account</h2>
          <p className="text-gray-600">Get started with DeckForge</p>
        </div>
      );
    }
  }
};

function App() {
  // Create a simple theme with purple colors
  const theme = {
    name: 'DeckForge Theme',
    tokens: {
      colors: {
        brand: {
          primary: {
            10: '#f5f3ff', // purple-50
            20: '#ede9fe', // purple-100
            40: '#c4b5fd', // purple-300
            60: '#a78bfa', // purple-400
            80: '#8b5cf6', // purple-500
            90: '#7c3aed', // purple-600
            100: '#6d28d9', // purple-700
          },
        },
      },
    },
  };

  return (
    <ThemeProvider theme={theme}>
      <AuthProvider>
        <div className="App">
          <DeckForgeApp 
            formFields={formFields}
            components={components}
            theme={theme}
          />
        </div>
      </AuthProvider>
    </ThemeProvider>
  );
}

export default App;